// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyProject_container__2moh-","labels":"CopyProject_labels__NTWlM","btn":"CopyProject_btn__2ZzAR"};